(function () {
    const config = window.uptalentPasswordReset || {};
    const messages = config.messages || {};

    const form = document.getElementById("uptalent-reset-password-form");
    const submitBtn = document.getElementById("password-reset-submit");
    const passwordInput = document.getElementById("password_1");
    const confirmInput = document.getElementById("password_2");
    const matchError = document.getElementById("password-reset-match-error");

    if (!form || !submitBtn || !passwordInput || !confirmInput) {
        return;
    }

    function setSubmitDisabled(isDisabled) {
        submitBtn.disabled = isDisabled;
        submitBtn.classList.toggle("password-reset__submit--disabled", isDisabled);
    }

    function clearMatchError() {
        confirmInput.classList.remove("password-reset__input--error");
        confirmInput.closest(".password-reset__field--confirm")?.classList.remove("password-reset__field--error");

        if (matchError) {
            matchError.hidden = true;
        }
    }

    function showMatchError() {
        confirmInput.classList.add("password-reset__input--error");
        confirmInput.closest(".password-reset__field--confirm")?.classList.add("password-reset__field--error");

        if (matchError) {
            matchError.textContent = messages.passwordMismatch || "Passwords do not match.";
            matchError.hidden = false;
        }

        setSubmitDisabled(true);
    }

    function isFormValid() {
        const password = passwordInput.value;
        const confirm = confirmInput.value;

        if (password.length < 1 || confirm.length < 1) {
            return false;
        }

        return password === confirm;
    }

    function updateSubmitState() {
        const password = passwordInput.value;
        const confirm = confirmInput.value;

        if (password && confirm && password !== confirm) {
            showMatchError();
            return;
        }

        clearMatchError();
        setSubmitDisabled(!isFormValid());
    }

    [passwordInput, confirmInput].forEach(function (input) {
        input.addEventListener("input", updateSubmitState);
        input.addEventListener("blur", updateSubmitState);
    });

    form.addEventListener("submit", function (event) {
        if (!isFormValid()) {
            event.preventDefault();
            updateSubmitState();
        }
    });

    updateSubmitState();
})();
